<template>
	<div class="billing">
		<Submenu
			:routes="{
				'billing.index': {
					title: $l.t('billing.statements', 'Statements'),
				},
				'billing.payment-methods': {
					title: $l.t('billing.payment-methods', 'Payment methods'),
					subroutes: ['billing.payment-methods.create']
				},
			}"
			:key="`${$l.detect()}${$route.name}`"
		/>
		<Invoices v-if="$route.name === 'billing.index'" data-test-id="billing-invoices"/>
		<PaymentMethodsList
      v-if="$route.name === 'billing.payment-methods'"
      data-test-id="payment-methods-index"
    />
    <PaymentMethodsCreate
      v-if="$route.name === 'billing.payment-methods.create'"
      data-test-id="payment-methods-show"
    />
	</div>
</template>

<script>
import Invoices from './index.vue';
import Submenu from '../../elements/Submenu.vue';
import PaymentMethods from './payment-methods.vue';
import InvoiceFragment from '../../fragments/Invoice.vue';
import PaymentMethodsList from '../payment-methods/index.vue';
import PaymentMethodsCreate from '../payment-methods/create.vue';

export default {
	components: {
		Submenu,
		PaymentMethodsList,
		PaymentMethodsCreate,
		Invoices,
		PaymentMethods,
		InvoiceFragment,
	},
};
</script>
